export default "__VITE_ASSET__d732af3d__"